import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=ca714788&scoped=true"
import script from "../../services/ticketing/Invoices.js?vue&type=script&lang=js&external"
export * from "../../services/ticketing/Invoices.js?vue&type=script&lang=js&external"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=ca714788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca714788",
  null
  
)

export default component.exports